// extracted by mini-css-extract-plugin
module.exports = {"NavLinks":"NavLinks_NavLinks__6QDe9","NavLinkActive":"NavLinks_NavLinkActive__2heGg"};